import { createStyles }     from "@mantine/core";
import { rooterMediaQuery } from "_styles/theme/mediaQuery";

export default createStyles ( theme => ( {
	header: {
		// display        : "flex",
		// alignItems     : "center",
		// justifyContent : "space-between",
		borderBottom : theme.other.darkMode ? "unset" : `1px solid ${ theme.other.colors.border.primary }`,
		padding      : "2rem 2rem"
		// height         : "65px"
	},
	titleContainer: {
		display        : "flex",
		alignItems     : "center",
		justifyContent : "space-between",
		width          : "100%"
	},
	backAndTitleContainer: {
		display    : "flex",
		alignItems : "center"
	},
	title: {
		fontSize: "2rem"
	},
	settingstitle: {
		fontSize : "1.4rem",
		padding  : "1rem 0"
	},
	backIcon: {
		width       : "2.5rem",
		cursor      : "pointer",
		height      : "3rem",
		marginRight : "1rem"
	},
	tickIcon: {
		width  : "3rem",
		cursor : "pointer",
		height : "3rem"
	},
	settingsFeedContent: {
		overflow : "auto",
		height   : "85vh",
		padding  : "1.5rem 2rem",

		[rooterMediaQuery.mobile]: {
			height: "100%"
		}
	}
} ) );

